import { Fragment, useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useMutation, useQuery } from "react-query";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";  
import logo from "../Components/Common/svg/dayemLogo.png";
import LoadingSpinner from "../Components/UI/spinner/index";
import { sendVendorOTP, verifyVendorOTP } from "../MyApi/vendor/auth";
import AuthContext from "../_helper/auth";
import { getCountriesUser } from "../MyApi/admin/countries/countries";
import PhoneField from "../Components/UI/phoneInput";
import OtpCountdown from "./usecountdown";
import permissionContext from "../_helper/permissions";
import { requestPermisson } from "../firebase";

const VendorSignin = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [phoneCode, setPhoneCode] = useState("+20");
  const [country_id, setCountryId] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [otpExpiry, setOtpExpiry] = useState("");
  const history = useNavigate();
  const { t, i18n } = useTranslation();
  const { authenticated, setAuthenticated } = useContext(AuthContext);
  const { setPermissions } = useContext(permissionContext);
  const staticPermissions = [
    "view_product",
    "create_product",
    "update_product",
    "delete_product",
    "manage_products",
    "manage_orders",
    "view_addon",
    "view_option",
    "view_order",
    "edit_working_hours"
  ];
  const sendOtpMutation = useMutation({
    mutationKey: ["sendVendorOTP"],
    mutationFn: (postData) => sendVendorOTP(postData),
    onSuccess: (data) => {
      if (data.success) {
        toast.success(`${data.message}`);
        setOtpSent(true);
        setOtpExpiry(data.data.otp_expires_at);
      }
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const verifyOtpMutation = useMutation({
    mutationKey: ["verifyVendorOTP"],
    mutationFn: (postData) => verifyVendorOTP(postData),
    onSuccess: (data) => {
      if (data.success) {
        const token = data.data.token;
        const vendor = data.data.user;

        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(vendor));
        localStorage.setItem("is_vendor", true);
        localStorage.setItem("i18nextLng", i18n.language);
        localStorage.setItem("permissions", JSON.stringify(staticPermissions));
        setPermissions(staticPermissions);
        setAuthenticated(true);

        history(`${process.env.PUBLIC_URL}/home`);
        toast.success(`${data.message}`);
      }
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const handleSendOTP = async () => {
    const device_token = await requestPermisson();
    console.log(device_token, "device_token");
    sendOtpMutation.mutate({
      phone,
      model_type: "vendor",
      phone_code: phoneCode,
      fcm_device: device_token,
      country_id,
    });
  };

  const handleVerifyOTP = async () => {
    const device_token = await requestPermisson();
    verifyOtpMutation.mutate({
      phone,
      phone_code: phoneCode,
      otp: otp,
      model_type: "vendor",
      fcm_device: device_token,
    });
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleCountryChange = (e) => {
    setCountryId(e.target.value);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (authenticated) {
    return <Navigate to={`${process.env.PUBLIC_URL}/vendor/choose-store`} />;
  }
  // تقارير و منتجات و الهوم و الطلبات و الadd_on , options
  return (
    <Fragment>
      <div
        className="p-0 container-fluid"
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
      >
        <header className="login-header"></header>
        <Row>
          <Col className="col-12">
            <div className="login-main">
              <div className="login-card">
                <div className="text-center mb-1">
                  <img src={logo} alt="logo" style={{width:"200px", "padding-bottom":"10px"}} />
                </div>

                <h1 className="login-title">تسجيل دخول البائع</h1>
                <p className="login-desc">سجّل دخولك للوصول إلى حسابك</p>
                <div className="theme-form">
                  <FormGroup>
                    <PhoneField
                      onChange={(values) => {
                        setPhone(values.phone);
                        setPhoneCode(values.phone_code);
                      }}
                      defaultCountry="EG"
                      phone={phone}
                      phone_code={phoneCode}
                      setErrors={setErrors}
                    />
                    {errors.phone && (
                      <div className="text-danger mt-1">{errors.phone}</div>
                    )}
                  </FormGroup>

                  {/* <FormGroup>
                    <Label className="col-form-label">الدولة</Label>
                    <select className="form-select" onChange={handleCountryChange} value={country_id}>
                      <option value="">اختر الدولة</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </FormGroup> */}

                  <FormGroup>
                    <div className="d-flex justify-content-between align-items-center">
                      <Label className="col-form-label">رمز التحقق (OTP)</Label>
                      {!otpSent && (
                        <button
                          type="button"
                          className={`btn btn-primary btn-sm ${sendOtpMutation.isLoading ? "loader" : ""}`}
                          disabled={sendOtpMutation.isLoading || !phone}
                          onClick={handleSendOTP}
                        >
                          {sendOtpMutation.isLoading
                            ? "جاري الإرسال..."
                            : "إرسال OTP"}
                        </button>
                      )}
                    </div>
                    <OtpCountdown otpExpiry={otpExpiry} />
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="ادخل رمز التحقق"
                      value={otp}
                      onChange={handleOtpChange}
                      disabled={!otpSent}
                    />
                  </FormGroup>

                  <div className="form-group mb-2">
                    <button
                      type="button"
                      className={`btn-block btn-primary position-relative btn w-100 ${
                        verifyOtpMutation.isLoading ? "loader" : ""
                      }`}
                      disabled={verifyOtpMutation.isLoading || !otp || !otpSent}
                      onClick={handleVerifyOTP}
                    >
                      <span>تسجيل الدخول</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default VendorSignin;
